export const colors = {
  // Brand Colors Main
  primary: '#ef6942',
  primaryDark: '#cb5938',
  secondary: '#70C3C3',
  success: '#8BC34A',
  error: '#CA0000',
  // Brand Colors Other
  bermudas: '#8AD5B1',
  aquaSqueeze: '#E2F3F3',

  // Basic Colors
  kilamanjaro: '#2B1202',
  judgeGray: '#554134',
  sandDune: '#807167',
  swirl: '#D5D0CC',
  desertStorm: '#F4F3F2',
  // Others
  serenade: '#FFF8EB',
  potPourri: '#F7EDEA',
  googleMapYellow: '#ffebc5',
  white: '#FFFFFF', // Background
  black: '#000000',
  silver: '#CCCCCC',
  lightGreen: '#69d25f',

  // transparentized values for box shadows
  mercury: '#CCCCCC80', // silver + 0.5 transparency
  facebookBlue: '#4267b2',
  bahamanSeaBlue: '#70c3c3',
  darkBahamanSeaBlue: '#547c76',
  anchorLinkColor: '#777777',
};

export type ColorType = keyof typeof colors;

const percentsToHex = (num: number) => {
  if (num <= 0) {
    return '00';
  }

  const normalized = num / 100;
  const decVal = Math.round(normalized * 255);
  return decVal.toString(16);
};

export const transparentizeColor = (hexColor: string, transparency: number) => {
  if (!hexColor) {
    return hexColor;
  }

  const pureThemedColor = hexColor.replace('#', '').substr(0, 6);
  return `#${pureThemedColor}${percentsToHex(transparency)}`;
};
